module.exports = __webpack_public_path__ + "img/Frame.44c1798f.svg";